import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-encadreurs-home',
  templateUrl: './encadreurs-home.component.html',
  styleUrls: ['./encadreurs-home.component.css']
})
export class EncadreursHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
